import { FmsApi } from "../fmsapi";
import BaseController from "./base";

export class AdminController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "admin");
  }

  public async ADM_sd_FairReqNotification(): Promise<any> {
    return await this.callApi("ADM_sd_FairReqNotification");
  }
}
